var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { Avatar, Typography } from '@robinpowered/ui-kit';
import { RobinAvatar } from './RobinAvatar';
// Used to convert a list of users into the appropriate 'user' view
// i.e. avatar group, avatar with text, etc
export var RobinUsers = function (_a) {
    var users = _a.users;
    if (!users || !users[0]) {
        return null;
    }
    if (users.length === 1) {
        var user = users[0];
        return (_jsxs(UserContainer, { children: [_jsx(RobinAvatar, { avatar: user.avatar, name: user.name }), _jsx(Typography.Text, { children: user.name })] }));
    }
    var avatarList = users.slice(0, 3).map(function (u) {
        return _jsx(RobinAvatar, { avatar: u === null || u === void 0 ? void 0 : u.avatar, name: u === null || u === void 0 ? void 0 : u.name }, u === null || u === void 0 ? void 0 : u.id);
    });
    return (_jsx(UserContainer, { children: _jsx(Avatar.Group, { size: 'small', max: { count: 3 }, children: avatarList }) }));
};
var UserContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  .ant-avatar {\n    flex-shrink: 0;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  .ant-avatar {\n    flex-shrink: 0;\n  }\n"])));
var templateObject_1;
